import { useState } from 'react';
import { useSnackbar } from 'notistack';
import { useNavigate } from 'react-router-dom';
import { Card, CircularProgress, Grid } from '@mui/material';
import axios from 'axios';
// Components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import MDTypography from 'components/MDTypography';
import MDButton from 'components/MDButton';
import MDInput from 'components/MDInput';
import MDBox from 'components/MDBox';

function EditProfile() {
  const [values, setValues] = useState({
    currentPassword: '',
    newPassword: '',
    retypePassword: '',
  });
  const navigate = useNavigate();
  const email = localStorage.getItem("email");
  const user_id = localStorage.getItem("user_id");
  const auth = localStorage.getItem("authToken");
  const [loading, setLoading] = useState(false);
  const { enqueueSnackbar } = useSnackbar();

  const handleChange = (e) => {
    setValues({ ...values, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
  
    // Validate the form fields
    if (!values.currentPassword || !values.newPassword || !values.retypePassword) {
      enqueueSnackbar('Please Provide All The Details !!!', { variant: 'error' });
      return;
    }
  
    if (values.newPassword !== values.retypePassword) {
      enqueueSnackbar('New passwords do not match. Please retype correctly.', { variant: 'error' });
      return;
    }
  
    setLoading(true);
  
    try {
      const requestData = {
        email: email,
        currentpassword: values.currentPassword,
        password: values.newPassword,
        user_id: user_id
      };
  
      const response = await axios.put(
        `${process.env.REACT_APP_BASEURL}/admin/users/update-password`,
        requestData,
        {
          headers: {
            Authorization: `Bearer ${auth}`,
          },
        }
      );
  
      if (response.data.success) {
        enqueueSnackbar('Password changed successfully', { variant: 'success' });
        localStorage.setItem('authToken', response.data.authToken);
        navigate('/profile');
      } else {
        enqueueSnackbar('Failed to change password', { variant: 'error' });
      }
    } catch (error) {
      console.error(error);
      enqueueSnackbar('Error occurred while changing the password. Please try again.', { variant: 'error' });
    }
  
    setLoading(false);
  };
  

  return (
    <DashboardLayout>
      <DashboardNavbar hidebreadcrumbTitle />

      <MDBox pt={3} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={3}
                px={2}
                variant="gradient"
                bgColor="info"
                borderRadius="lg"
                coloredShadow="info"
              >
                <MDTypography variant="h6" color="white">
                  Edit password
                </MDTypography>
              </MDBox>

              <MDBox p={3} component="form" role="form">
                <MDBox p={1}>
                  <MDInput
                    type="password"
                    label="Current Password"
                    value={values.currentPassword}
                    name="currentPassword"
                    margin="dense"
                    fullWidth
                    onChange={handleChange}
                  />
                </MDBox>

                <MDBox p={1}>
                  <MDInput
                    type="password"
                    label="New Password"
                    value={values.newPassword}
                    name="newPassword"
                    margin="dense"
                    fullWidth
                    onChange={handleChange}
                  />
                </MDBox>
                <MDBox p={1}>
                  <MDInput
                    type="password"
                    label="Re-type New Password"
                    value={values.retypePassword}
                    name="retypePassword"
                    margin="dense"
                    fullWidth
                    onChange={handleChange}
                  />
                </MDBox>
                <Grid container direction="row" justifyContent="flex-end" p={2} pb={0.5}>
                  <MDButton variant="gradient" color="info" onClick={handleSubmit} disabled={loading}>
                    {loading ? <CircularProgress size={20} sx={{ color: 'inherit' }} /> : 'Change Password'}
                  </MDButton>
                </Grid>
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
    </DashboardLayout>
  );
}

export default EditProfile;
